'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _dec2, _class; // Lib


// Custom Decorators


// Actions


// Components


// Constants


// Styles


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRouter = require('react-router');

var _milanoteForm = require('../../../components/form/milanoteForm');

var _milanoteForm2 = _interopRequireDefault(_milanoteForm);

var _authActions = require('../../authActions');

var _navigationActions = require('../../../reducers/navigationActions');

var _FullScreenModal = require('../../../components/modal/FullScreenModal');

var _FullScreenModal2 = _interopRequireDefault(_FullScreenModal);

var _Icon = require('../../../components/icons/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _PasswordInput = require('../../../components/form/fields/PasswordInput');

var _PasswordInput2 = _interopRequireDefault(_PasswordInput);

var _Form = require('../../../components/form/Form');

var _Form2 = _interopRequireDefault(_Form);

var _FormButton = require('../../../components/form/FormButton');

var _FormButton2 = _interopRequireDefault(_FormButton);

var _FormInput = require('../../../components/form/fields/FormInput');

var _FormInput2 = _interopRequireDefault(_FormInput);

var _FieldValidationMessages = require('../../../components/form/validation/FieldValidationMessages');

var _FieldValidationMessages2 = _interopRequireDefault(_FieldValidationMessages);

var _StaticPageLink = require('../../../components/static/StaticPageLink');

var _StaticPageLink2 = _interopRequireDefault(_StaticPageLink);

var _PrimaryErrorMessage = require('../../../components/form/messages/PrimaryErrorMessage');

var _PrimaryErrorMessage2 = _interopRequireDefault(_PrimaryErrorMessage);

var _staticPageConstants = require('../../../components/static/staticPageConstants');

var _loginFormConstants = require('./loginFormConstants');

require('./Login.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapStateToProps = function mapStateToProps(state) {
    return {
        isGuest: state.getIn(['app', 'currentUser', 'isGuest'])
    };
};

// Redux connect methods
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        onSubmit: function onSubmit(_ref) {
            var email = _ref.email,
                password = _ref.password;
            return dispatch((0, _authActions.login)(email, password));
        },
        navigateToWorkspace: function navigateToWorkspace() {
            return dispatch((0, _navigationActions.redirectLoggedInUserToWorkspace)());
        }
    };
};

var Login = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec2 = (0, _milanoteForm2.default)({ form: _loginFormConstants.LOGIN_FORM_NAME, fieldsConfig: _loginFormConstants.LOGIN_FORM_FIELDS }), _dec(_class = _dec2(_class = function (_React$Component) {
    _inherits(Login, _React$Component);

    function Login() {
        _classCallCheck(this, Login);

        return _possibleConstructorReturn(this, (Login.__proto__ || Object.getPrototypeOf(Login)).apply(this, arguments));
    }

    _createClass(Login, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _props = this.props,
                isGuest = _props.isGuest,
                navigateToWorkspace = _props.navigateToWorkspace;

            if (!isGuest) return navigateToWorkspace();
        }

        /**
         * Focuses the email input field when the page loads.
         */

    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.refs.email.focus();
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                submitInterceptor = _props2.submitInterceptor,
                sanitisedErrors = _props2.sanitisedErrors,
                submitting = _props2.submitting,
                showingErrors = _props2.showingErrors,
                primaryError = _props2.primaryError,
                dirtySinceSubmission = _props2.dirtySinceSubmission;


            return _react2.default.createElement(
                _FullScreenModal2.default,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'logo' },
                    _react2.default.createElement(_Icon2.default, { name: 'milanote-logo-large' })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'heading' },
                    _react2.default.createElement(
                        'h2',
                        null,
                        'Log in to Milanote'
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'section' },
                    _react2.default.createElement(
                        _Form2.default,
                        { className: (0, _classnames2.default)('auth-form form', { submitting: submitting }), onSubmit: submitInterceptor,
                            noValidate: true },
                        _react2.default.createElement(
                            'div',
                            { className: 'form-row' },
                            _react2.default.createElement(
                                'div',
                                { className: 'field-info' },
                                _react2.default.createElement(
                                    'label',
                                    { className: 'field-label', htmlFor: 'email' },
                                    'Your email'
                                ),
                                _react2.default.createElement(_FieldValidationMessages2.default, { sanitisedError: sanitisedErrors.email })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'field-row' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'field' },
                                    _react2.default.createElement(_FormInput2.default, _extends({}, this.props, { ref: 'email',
                                        name: _loginFormConstants.LOGIN_FORM_FIELDS.email.name,
                                        type: _loginFormConstants.LOGIN_FORM_FIELDS.email.type,
                                        placeholder: 'you@domain.com' }))
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-row' },
                            _react2.default.createElement(
                                'div',
                                { className: 'field-info' },
                                _react2.default.createElement(
                                    'label',
                                    { className: 'field-label', htmlFor: 'password' },
                                    'Your password'
                                ),
                                _react2.default.createElement(_FieldValidationMessages2.default, { sanitisedError: sanitisedErrors.password })
                            ),
                            _react2.default.createElement(_PasswordInput2.default, _extends({}, this.props, {
                                name: _loginFormConstants.LOGIN_FORM_FIELDS.password.name,
                                canShowPassword: false }))
                        ),
                        _react2.default.createElement(
                            _FormButton2.default,
                            { type: 'submit', className: 'row primary', disabled: submitting || showingErrors },
                            'Log in'
                        ),
                        _react2.default.createElement(_PrimaryErrorMessage2.default, { message: primaryError && primaryError.message,
                            show: !!primaryError && !dirtySinceSubmission && !submitting }),
                        _react2.default.createElement(
                            'div',
                            { className: 'disclaimer' },
                            'By using Milanote you are agreeing to our\xA0',
                            _react2.default.createElement(_StaticPageLink2.default, { config: _staticPageConstants.STATIC_PAGE.termsOfService }),
                            '\xA0and our\xA0',
                            _react2.default.createElement(_StaticPageLink2.default, { config: _staticPageConstants.STATIC_PAGE.privacyPolicy })
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'section' },
                    _react2.default.createElement(
                        'div',
                        { className: 'forgotten-password' },
                        'Forgotten your password?',
                        ' ',
                        _react2.default.createElement(
                            _reactRouter.Link,
                            { to: '/forgotten-password' },
                            'Reset it'
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'section' },
                        _react2.default.createElement(
                            'div',
                            { className: 'register-instead' },
                            'Don\'t have an account?',
                            ' ',
                            _react2.default.createElement(
                                _reactRouter.Link,
                                { to: '/register' },
                                'Sign up now'
                            )
                        )
                    )
                )
            );
        }
    }]);

    return Login;
}(_react2.default.Component)) || _class) || _class);
exports.default = Login;


Login.propTypes = {
    loginSubmit: _propTypes2.default.func,
    fields: _propTypes2.default.object,
    submitInterceptor: _propTypes2.default.func,
    submitFailed: _propTypes2.default.bool,
    showingErrors: _propTypes2.default.bool,
    submitting: _propTypes2.default.bool,
    navigateToWorkspace: _propTypes2.default.func,
    onChange: _propTypes2.default.func,
    sanitisedErrors: _propTypes2.default.object,
    primaryError: _propTypes2.default.object,
    dirtySinceSubmission: _propTypes2.default.bool,
    isGuest: _propTypes2.default.bool
};


//////////////////
// WEBPACK FOOTER
// ./src/client/auth/modals/login/Login.js
// module id = 1682
// module chunks = 0